import { Command } from 'commands/Commands';

export class ChangeMemberVisibility extends Command {
  type: string = 'Member.ChangeVisibility';
  priority = 100;
}
